export default class EducationsFieldsNames {
    static readonly EducationsName = 'educations';
}
